import React from 'react';
import { Card, CardContent, Typography, Button,Grid } from '@mui/material';
import CardHeader from '@mui/material/CardHeader';
import { orange } from '@mui/material/colors';

//Images
import pre_approved from "./images/loan.png";
import money_view from "./images/money_views.png";
import tick from "./images/green-check-mark-circular-tick-16215.png"
import "./creditScoreRes.css";
function OfferCard({ data }) {
  // console.log("OfferData:",data)
  // const isPreapproved = preApprovalData?.["log_status"] === 'Approved';

  return (
    // <Grid item xs={12} sm={6} md={4} lg={4} 
    // className='card-container'
    // className='card'
    // >
    <Card
    // className='card' 
       sx={{ marginTop: '20px' , minWidth: "340px", marginRight: "11px"}}
    >
      {/* <CardHeader> */}
        <div  style={{background:"#e1ebf5" , color: "#2E3092" , textAlign: "center", padding: "8px" }}><b>Pre-Approved</b></div>
         
      {/* </CardHeader>   */}
      <CardContent>
        <Typography variant="div" padding={1} ><img src={pre_approved}  alt="" /><b> {data?.bank_name}</b></Typography>
        <br/>
        {/* <Typography variant="div" padding={1} ><img src={money_view} width="32px" alt="" /> <b>Money View</b></Typography> */}
        {/* <br/> */}
        <Typography variant="h6" padding={1} paddingTop={3} style={{ color: "#2E3092" }}>
  <b>
    {data?.approved_amount === null
      ? "You have a Pre-Approved loan of upto Rs 100000"
      : `You have a Pre-Approved loan of Rs ${data?.approved_amount}`}
  </b>
</Typography>

        <Typography variant="body2" padding={1}></Typography>
        <div style={{paddingTop: 10 , paddingBottom: 20}}>
        <Typography variant="h7" padding={1}><img src={tick} width="16px" alt="" />  Low Interest Rate </Typography>
        <br/>
        {/* <Typography variant="" padding={1}><img src={tick} width="16px" alt="" />  No Income Docs Required </Typography> */}
        {/* <br/> */}
        <Typography variant="" padding={1}><img src={tick} width="16px" alt="" />  Completely Digital Process </Typography>
        <br/>
        </div>
        <Typography padding={1}>
          <Button variant="contained" style={{background: "#2E3092"}} >
            <span onClick={()=>window.open(data?.apply_link,"_blank")}>
            Apply Now
            </span>
          </Button>
        </Typography>
      </CardContent>
    </Card>
    // </Grid>
  );
}

export default OfferCard;
